const controleAcessoRotasConsts = {
    somenteRevenda: 1,
    somenteIndustria: 2,
    revendaEIndustria: 3,
};

export default controleAcessoRotasConsts;
